import { createAuthClient } from "better-auth/react";
import {
  magicLinkClient,
  adminClient,
  organizationClient,
  twoFactorClient,
  inferOrgAdditionalFields,
} from "better-auth/client/plugins";
import { adminAc, orgAc, adminRoles, orgRoles } from "@/lib/permissions";
import { sanitizeRedirectUrl } from "@/lib/safe-redirect";
import { stashTwoFactorMethods } from "@/lib/web/two-factor-methods";
import type { auth } from "@/lib/auth";

export const authClient = createAuthClient({
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect({ twoFactorMethods }) {
        if (typeof window === "undefined") return;
        // Carry the user's actual 2FA methods across to the verify screen so it
        // can default to one they can satisfy (a user who enrolled without an
        // authenticator app gets the email screen, not a TOTP prompt).
        stashTwoFactorMethods(twoFactorMethods);
        const callbackUrl = sanitizeRedirectUrl(
          new URLSearchParams(window.location.search).get("callbackUrl"),
          window.location.origin
        );
        window.location.href = `/auth/verify-2fa?callbackUrl=${encodeURIComponent(callbackUrl)}`;
      },
    }),
    magicLinkClient(),
    adminClient({
      ac: adminAc,
      roles: adminRoles,
    }),
    organizationClient({
      ac: orgAc,
      roles: orgRoles,
      dynamicAccessControl: {
        enabled: true,
      },
      schema: inferOrgAdditionalFields<typeof auth>(),
    }),
  ],
});
